// Extended encyclopedia content — Konesans (Knowledge).
// Curated, factual and non-partisan reference material about Haiti.

export const TIMELINE = [
  { year: "1492", event: "Christopher Columbus lands on the island the Taíno called Ayiti." },
  { year: "1697", event: "Treaty of Ryswick — western third of Hispaniola becomes French Saint-Domingue." },
  { year: "1791", event: "August 14 — Bois Caïman ceremony ignites the Haitian Revolution." },
  { year: "1801", event: "Toussaint Louverture drafts the first constitution of Saint-Domingue." },
  { year: "1803", event: "Nov 18 — Battle of Vertières; Dessalines defeats Napoleon's forces." },
  { year: "1803", event: "May 18 — First Haitian flag stitched by Catherine Flon at Arcahaie." },
  { year: "1804", event: "January 1 — Independence proclaimed at Gonaïves. Haiti is born." },
  { year: "1806", event: "Assassination of Dessalines; Haiti splits into Nord (Christophe) and Sud (Pétion)." },
  { year: "1820", event: "Reunification of Haiti under Jean-Pierre Boyer." },
  { year: "1825", event: "France extorts 150 million gold francs as indemnity for slaveholders." },
  { year: "1915", event: "US military occupation begins; lasts 19 years." },
  { year: "1937", event: "Parsley Massacre — thousands of Haitians killed on the Dominican border." },
  { year: "1957", event: "François Duvalier ('Papa Doc') elected; a 29-year dictatorship begins." },
  { year: "1986", event: "Jean-Claude 'Baby Doc' Duvalier ousted; new democratic era begins." },
  { year: "1990", event: "Jean-Bertrand Aristide wins first free democratic election." },
  { year: "2010", event: "January 12 — devastating 7.0 earthquake strikes Port-au-Prince." },
  { year: "2021", event: "UNESCO inscribes soup joumou as Intangible Cultural Heritage." },
  { year: "2022", event: "Sud earthquake reconstruction and diaspora mobilization." },
];

export const FIGURES = [
  { name: "Toussaint Louverture", role: "Revolutionary Leader (1743 – 1803)", note: "The general who unified the enslaved into an army that defeated three colonial powers." },
  { name: "Jean-Jacques Dessalines", role: "Founding Father (1758 – 1806)", note: "Completed the revolution and declared Haitian independence on Jan 1, 1804." },
  { name: "Henri Christophe", role: "King of Haiti (1767 – 1820)", note: "Built the Citadelle Laferrière, the largest fortress in the Americas." },
  { name: "Catherine Flon", role: "Seamstress of the Flag (b. 1772)", note: "Stitched the first Haitian flag at Arcahaie on May 18, 1803." },
  { name: "Sanité Bélair", role: "Revolutionary (1781 – 1802)", note: "Lieutenant in Dessalines' army. Refused a blindfold at her execution." },
  { name: "Cécile Fatiman", role: "Mambo / Priestess", note: "Co-led the Bois Caïman ceremony that launched the revolution." },
  { name: "Alexandre Pétion", role: "President of the Republic (1770 – 1818)", note: "Funded Simón Bolívar's fight to liberate South America." },
  { name: "Boukman Dutty", role: "Houngan (d. 1791)", note: "Vodou priest who called the enslaved to arms at Bois Caïman." },
  { name: "Jacques Roumain", role: "Novelist (1907 – 1944)", note: "Author of Gouverneurs de la Rosée, a founding text of Haitian literature." },
  { name: "Jean Price-Mars", role: "Ethnologist (1876 – 1969)", note: "Author of Ainsi Parla l'Oncle — reclaimed Haitian folk culture." },
  { name: "Hector Hyppolite", role: "Painter (1894 – 1948)", note: "Houngan and painter who brought Haitian art to the world stage." },
  { name: "Nemours Jean-Baptiste", role: "Bandleader (1918 – 1985)", note: "Inventor of Kompa Direk in 1955." },
  { name: "Wyclef Jean", role: "Musician (b. 1969)", note: "Fugees co-founder; global ambassador of Haitian music." },
  { name: "Edwidge Danticat", role: "Author (b. 1969)", note: "MacArthur fellow. Author of Breath, Eyes, Memory and The Farming of Bones." },
];

export const SYMBOLS = [
  {
    title: "The Flag",
    body: "Adopted May 18, 1803 at Arcahaie. Blue over red horizontal bands with the coat of arms centred. Symbolizes the union of Black and mulatto Haitians against colonial France.",
  },
  {
    title: "Coat of Arms",
    body: "A palm tree crowned with the Phrygian cap of liberty. Below: cannons, cannonballs, drums, flags and a broken chain. Motto: L'union fait la force.",
  },
  {
    title: "Motto",
    body: "L'union fait la force — 'Unity makes strength.' The founding principle of the republic.",
  },
  {
    title: "National Anthem",
    body: "La Dessalinienne, written by Justin Lhérisson in 1904 for the centennial of independence. Composed by Nicolas Geffrard.",
  },
  {
    title: "National Flower",
    body: "The Hibiscus (Choublak) — vibrant red, ubiquitous in Haitian gardens and folk imagery.",
  },
  {
    title: "National Bird",
    body: "The Hispaniolan Trogon (Priotelus roseigaster) — endemic to the island, green-and-red plumage.",
  },
];

export const KREYOL_PHRASES = [
  { kr: "Bonjou", en: "Good morning / Hello" },
  { kr: "Bonswa", en: "Good afternoon / Good evening" },
  { kr: "Kijan ou ye?", en: "How are you?" },
  { kr: "M byen, mèsi.", en: "I'm well, thank you." },
  { kr: "Kouman ou rele?", en: "What is your name?" },
  { kr: "M rele…", en: "My name is…" },
  { kr: "Mèsi anpil", en: "Thank you very much" },
  { kr: "Souple / Silvouplè", en: "Please" },
  { kr: "Padon", en: "Excuse me / Sorry" },
  { kr: "Wi / Non", en: "Yes / No" },
  { kr: "M pa konprann", en: "I don't understand" },
  { kr: "Kote…?", en: "Where is…?" },
  { kr: "Konbyen sa koute?", en: "How much does it cost?" },
  { kr: "M grangou", en: "I'm hungry" },
  { kr: "M swaf", en: "I'm thirsty" },
  { kr: "Mwen renmen ou", en: "I love you" },
  { kr: "Bon apeti", en: "Enjoy your meal" },
  { kr: "Ayiti cheri", en: "Beloved Haiti" },
  { kr: "N ap boule", en: "We're doing well (informal)" },
  { kr: "Sak pase? / N ap kenbe.", en: "What's up? / We're holding on." },
];

export const PROVERBS = [
  { kr: "Piti piti zwazo fè nich li.", en: "Little by little, the bird builds its nest." },
  { kr: "Bèl anteman pa vle di paradi.", en: "A beautiful funeral doesn't mean paradise." },
  { kr: "Dèyè mòn gen mòn.", en: "Behind mountains there are more mountains." },
  { kr: "Konstitisyon se papye, bayonèt se fè.", en: "Constitution is paper, bayonet is iron." },
  { kr: "Chak koukouy klere pou je l.", en: "Every firefly shines for its own eyes." },
  { kr: "Bourik chaje pa kanpe.", en: "A loaded donkey doesn't stop." },
  { kr: "Lang pa gen zo.", en: "The tongue has no bones (words are cheap)." },
  { kr: "Sa ki pa touye ou fè ou pi fò.", en: "What doesn't kill you makes you stronger." },
];
